export default "__VITE_ASSET__9010dfa5__"